import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogRef } from '@ngneat/dialog';
import { User } from '@app/shared/models/user';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import * as fromMembers from '../../reducers/members.reducer';
import { MembersActions } from '../../actions';

@Component({
  selector: 'app-modal-delete-member',
  templateUrl: './modal-delete-member.component.html',
  styleUrls: ['./modal-delete-member.component.scss']
})
export class ModalDeleteMemberComponent implements OnInit, OnDestroy {
  memberDeleting$: Observable<boolean>;
  memberDeleted$: Observable<boolean>;

  subscriptions: Subscription[] = [];
  memberToDelete: User;
  teamId: string;

  constructor(private store$: Store<fromMembers.State>, private router: Router, public ref: DialogRef) {
    this.memberToDelete = this.ref.data.memberToDelete;
    this.teamId = this.ref.data.teamId;

    this.memberDeleting$ = this.store$.select(fromMembers.getDeleteMemberProcessing);
    this.memberDeleted$ = this.store$.select(fromMembers.getDeleteMemberSuccess);
  }

  ngOnInit() { }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  deleteMember() {
    this.store$.dispatch(MembersActions.deleteMember({ teamId: this.teamId, member: this.memberToDelete }));
    this.subscriptions.push(this.memberDeleted$.subscribe(res => {
      if (res) {
        this.closeModal();
        this.router.navigateByUrl('/account/team/' + this.teamId + '/members');
      }
    }));
  }

  closeModal() {
    this.ref.close();
  }
}
